import { styled } from 'styled-components'

export const Root = styled.dialog`
  position: relative;
  border: none;
  padding: 0;
  border-radius: 50px;
`
